export default "__VITE_ASSET__e32ab456__"